import React from 'react';
import {Link} from 'react-router-dom';

import Icon from './Icon';
import Avatar from './Avatar';
import createLink from "../../libs/createLink";


const UserStatList = (props) => {
    return (
        <div id="userStatList">
            <div className="container">
                <div className="card">
                    <div className="topline">
                        {props.type === "following" && (
                            <span><span
                                className="userStatList-username">{props.User && props.User.username}</span> suit {props.following && (props.following.length || 0)} personne{props.following && props.following.length >= 2 && 's'}</span>
                        )}
                        <span onClick={() => props.handleClose()}><Icon type="close"/></span>
                    </div>
                    <div className="user-stat-list">
                        {props.type === "following" && (
                            <ul className="user-stat-list-container">
                                {props.following && props.following.map((user, index) =>
                                    <li key={index}>
                                        <Link to={createLink('userProfile', user)}
                                              onClick={() => props.handleClose()}>
                                            <Avatar avatar={user && user.profile && user.profile.avatar}
                                                    gender={user && user.profile && user.profile.gender}
                                                    className="user-thumb" alt=""/>
                                            {user.username}
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
};


export default UserStatList;
